export const TIME_ZONES = [
  { label: "Eastern",  value: "America/New_York" },
  { label: "Central",   value: "America/Chicago" },
  { label: "Mountain",   value: "America/Denver" },
  { label: "Pacific", value: "America/Los_Angeles" }, // note the 's'
  { label: "Alaska",  value: "America/Anchorage" },
  { label: "Hawaii",   value: "Pacific/Honolulu" },
];
